<div [ngClass]="collapsed ? 'collapsed' : 'no-collapsed'">
  <div
    class="sidenav"
    (mouseenter)="openSidenav()"
    (mouseleave)="closeSidenav()">
    <div class="head">
      <div class="logo">
        <div class="logo-container">
          @if (isSmallScreen) {
            @if (collapsed) {
              <button
                title="Activer / désactiver la barre de navigation"
                class="btn-close"
                (click)="toggleSidenav()"
                (mouseenter)="this.canOpen = false"
                (mouseleave)="this.canOpen = true">
                <mat-icon class="whiteIcon">arrow_back</mat-icon>
              </button>
            }
          } @else {
            <button
              title="Activer / désactiver la barre de navigation"
              class="btn-close"
              (click)="toggleCollapse()"
              (mouseenter)="this.canOpen = false"
              (mouseleave)="this.canOpen = true">
              <mat-icon class="whiteIcon">menu</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>
    <div class="content">
      <div class="account">
        @if (collapsed) {
          @if (currentUser?.avsAlign !== false) {
            <div class="username">
              {{ currentUser?.firstName }} {{ currentUser?.lastName }}
            </div>
          } @else {
            <div class="username">
              {{ currentUser?.misalignedFirstname }}
              {{ currentUser?.misalignedName }}
            </div>
          }
          @if (currentUser?.avsAlign !== false) {
            <div class="email">
              {{ currentUser?.officialemail }}
            </div>
          } @else {
            <div class="username">
              {{ misalignedEmail }}
            </div>
          }
        }
        <div
          aria-hidden="true"
          class="avatar-container"
          (click)="isPasswordChangeDisabled ? null : navigateSelf()"
          [ngStyle]="{
            'pointer-events': isPasswordChangeDisabled ? 'none' : 'auto',
          }">
          <img
            [src]="
              selectedFileUrl
                ? selectedFileUrl
                : '../../../assets/images/avatars/avatar.png'
            "
            class="avatar"
            alt="" />
        </div>
      </div>
      <ul class="sidenav-nav">
        @for (section of navigation; track section) {
          <div class="group-item">
            <div class="item-title">
              <span>{{ section.translate | translate }}</span>
            </div>
            @for (children of section.children; track children) {
              <li class="sidenav-nav-item">
                <div class="item">
                  <a
                    [ngClass]="{ maintenance: children.maintenance }"
                    class="sidenav-nav-link"
                    [routerLink]="[children.url]"
                    routerLinkActive="active open"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <mat-icon class="sidenav-link-icon">{{
                      children.icon
                    }}</mat-icon>
                    @if (collapsed) {
                      <span class="sidenav-link-text">{{
                        children.translate | translate
                      }}</span>
                    }
                    @if (children.children) {
                      <mat-icon class="sidenav-link-icon collapsable-arrow"
                        >keyboard_arrow_right</mat-icon
                      >
                    }
                  </a>
                </div>
                @for (childrens of children.children; track childrens) {
                  <div class="item-child">
                    <a
                      [ngClass]="{ maintenance: childrens.maintenance }"
                      class="sidenav-nav-link"
                      [routerLink]="[childrens.url]"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }">
                      <mat-icon class="sidenav-link-icon">{{
                        childrens.icon
                      }}</mat-icon>
                      @if (collapsed) {
                        <span class="sidenav-link-text">{{
                          childrens.translate | translate
                        }}</span>
                      }
                    </a>
                  </div>
                }
              </li>
            }
          </div>
        }
        @if (!isStudent) {
          <div class="group-item">
            <div class="item-title">
              <span>{{ 'SIDENAV.SUPPORT' | translate }}</span>
            </div>
            @for (support of navSupport; track support.label) {
              <li class="sidenav-nav-item">
                <div class="item">
                  <a
                    class="sidenav-nav-link"
                    [href]="[support.link]"
                    target="_blank">
                    <mat-icon class="sidenav-link-icon">{{
                      support.icon
                    }}</mat-icon>
                    @if (collapsed) {
                      <span class="sidenav-link-text">{{
                        support.label | translate
                      }}</span>
                    }
                  </a>
                </div>
              </li>
            }
          </div>
        }
      </ul>
    </div>
    <div class="logout-sidenav">
      <button class="logout" mat-raised-button color="warn" (click)="logout()">
        <mat-icon class="logout-icon">exit_to_app</mat-icon>
        @if (collapsed) {
          <span>Logout</span>
        }
      </button>
    </div>
  </div>
</div>
